var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

var _isSP;
var windowW = window.innerWidth;
var prewidth = window.innerWidth;

//preload
import {preload} from "../include/module";
preload();

//showMovie
// import {showMovie} from "../include/module";
// showMovie();

//toggleHeader
// import {toggleHeader} from "../include/module";
// toggleHeader();

// $(window).on('resize load' , function() {
//   if(windowW <= 1024){
//     _isSP = true;
//   } else {
//     _isSP = false;
//   };

//   //リサイズ処理 ブレイクポイントを跨いだらリロード
//   var nowWidth = window.innerWidth;
//   if(prewidth !== nowWidth){
//     if(prewidth < 1025) {
//       if(nowWidth >= 1025){
//         location.reload();
//       }
//     }else {
//       if(nowWidth < 1025){
//         location.reload();
//       }
//     }
//   };
// });



$(window).on('load' , function() {

  // scrollIndexAnime();
  // topSlide();
  discSlide();
});


// ------------------------------------------------------------------------
// discSlide
// ----- BOTH
// ------------------------------------------------------------------------
const discSlide = () => {

  var discSwiper;
  let options = {};

  //1枚の時
  if ( $(".index-Slider_Item").length == 1 ) {
    options = {
      // autoplay: {
      //   delay: 4000,
      //   disableOnInteraction: false
      // },
      autoHeight: false,
      // loop: true,
      // loopAdditionalSlides: 1,//一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
      // grabCursor: true,
      watchOverflow: true,//スライドの枚数がスライダー生成の条件に満たさない時）、コントロール関係を削除してスライド機能もなくす。
      speed: 1000,
      // width: 760,
      slidesPerView: 1,
      breakpoints: {
        1024: {
          spaceBetween: 10,
          slidesPerView: 1
        }
      },
      pagination: {
        el: '.index-Slider_Pagination',
        clickable: true
      },
      on: {
      }
    }
  } else {
    options = {
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      autoHeight: false,
      loop: true,
      loopAdditionalSlides: 1,//一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
      grabCursor: true,
      watchOverflow: true,//スライドの枚数がスライダー生成の条件に満たさない時）、コントロール関係を削除してスライド機能もなくす。
      speed: 1000,
      // width: 760,
      slidesPerView: 1,
      breakpoints: {
        1024: {
          spaceBetween: 10,
          slidesPerView: 1
        }
      },
      pagination: {
        el: '.index-Slider_Pagination',
        clickable: true
      },
      on: {
      }

    }
  }



  discSwiper = new Swiper('.index-Slider_Container', options);

};



// WEBPACK FOOTER //
// ./src/hayamisaori_v0/assets/js/index/script.js